<template>
  <div v-if="catalogSectionList.count && catalogSectionList.query" class="catalog-search">
    <DefTitle>
      <h1>
        {{ messages.search }}
        <span class="catalog-search__search">{{ catalogSectionList.query }}</span>
      </h1>
    </DefTitle>
    <p class="catalog-search__found">{{ messages.find }}</p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';

export default {
  name: 'CatalogSearch',
  components: { DefTitle },
  computed: {
    ...mapState({
      catalogSectionList: ({ catalog }) => catalog.data.catalogSectionList,
      messages: ({ results }) => results.messages,
    }),
  },
};
</script>

<style lang="scss" scoped>
.catalog-search {
  //margin-bottom: 16px;
  margin: 16px 0;
  @include point-md {
    margin-bottom: 24px;
  }
  @include point-lg {
    margin-bottom: 32px;
  }
  &__search {
    background-color: #efe6cc;
    padding: 0 2px;
  }
  &__found {
    font-weight: 500;
    font-size: rem(14);
    line-height: 125%;
    color: var(--color-dark-grey);
  }
  :deep(.def-title) {
    margin-bottom: 8px;
  }
}
</style>
